import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { AppFloatingConfigurator } from '../layout/component/app.floatingconfigurator';
import { CommonModule } from '@angular/common';
import { UserService } from '../pages/service/user.service';// Adjust the import path as necessary
import { HttpClientModule } from '@angular/common/http';

@Component({
  selector: 'app-forgot-password',
  imports: [ButtonModule, HttpClientModule,CheckboxModule, InputTextModule, PasswordModule, RouterModule, RippleModule, AppFloatingConfigurator, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  submitted = false;
 email: string = '';
newPassword: string = '';
confirmPassword: string = '';
  errorMessage = '';
  checked = '';
  message: string = '';
  error: string = '';

  constructor(private fb: FormBuilder, private router: Router, private userService: UserService) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
  }

  get f() {
    return this.forgotPasswordForm.controls;
  }

 onSubmit() {
    console.log('Submit clicked');
  this.submitted = true;
console.log('Submit clicked1');
  if (this.forgotPasswordForm.invalid) {
    console.log('Submit clicked2');
    return;
  }
console.log('Submit clicked3');
  const { email, newPassword, confirmPassword } = this.forgotPasswordForm.value;
  this.userService.forgotPassword({ email, newPassword, confirmPassword }).subscribe({
    next: () => {
      this.message = 'Password reset successful!';
      this.error = '';
      // Navigate to login after success
      this.router.navigate(['/login']);
    },
    error: (err: { error: { message: string; }; }) => {
      this.error = err?.error?.message || 'Password reset failed.';
      this.message = '';
    }
  });
}
}
